import {
  createBaseConnectorClass,
  CONNECTOR_ERRORS,
} from '@descope-ui/common/base-classes';

const RADAR_AUTOCOMPLETE_URL = 'https://api.radar.io/v1/search/autocomplete';

export class RadarConnector extends createBaseConnectorClass() {
  // eslint-disable-next-line class-methods-use-this
  getRequiredParams() {
    return ['public-api-key'];
  }

  // eslint-disable-next-line class-methods-use-this
  getOptionalParams() {
    return [
      {
        key: 'layers',
        attribute: 'address-types',
      },
      {
        key: 'limit',
        attribute: 'address-limit',
      },
      {
        key: 'lang',
        attribute: 'address-language',
      },
      {
        key: 'countryCode',
        attribute: 'address-region',
      },
    ];
  }

  async _fetchResults(query) {
    if (!query?.trim()) {
      return { results: [] };
    }

    const apiKey = this.getAttribute('public-api-key');
    const params = new URLSearchParams({
      query: query.trim(),
    });

    // Add optional parameters
    this.getOptionalParams().forEach(({ attribute, key, defaultValue }) => {
      const value = this.getAttribute(attribute) || defaultValue;
      if (value) {
        if (key === 'layers' || key === 'countryCode') {
          params.append(
            key,
            value
              .split(',')
              .map((type) => type.trim())
              .filter(Boolean)
              .join(','),
          );
        } else {
          params.append(key, value);
        }
      }
    });

    try {
      const response = await fetch(
        `${RADAR_AUTOCOMPLETE_URL}?${params.toString()}`,
        {
          headers: {
            Authorization: apiKey,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Radar API returned ${response.status}`);
      }

      const data = await response.json();
      return this.#parseResponse(data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Radar Places Autocomplete failed:', error);
      return { results: [], error: CONNECTOR_ERRORS.FETCH_RESULTS_ERROR };
    }
  }

  // eslint-disable-next-line class-methods-use-this
  #parseResponse(data) {
    if (!data?.addresses?.length) {
      return { results: [] };
    }
    return {
      results: data.addresses.map((address) => ({
        label: address.formattedAddress,
        value: address.formattedAddress,
      })),
    };
  }
}
